import React, { useEffect, useState } from 'react';
import Container from '../../components/UI/Container/Container';
import Block from '../../components/UI/Block/Block';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Alert,
  Avatar,
  Button,
  Descriptions,
  Divider,
  Flex,
  Form,
  Input,
  InputNumber,
  Menu,
  message,
  Result,
  Select,
  Space,
  Spin,
  Table,
  Tabs,
  Tag,
  Typography,
  Upload
} from 'antd';
import { FileTextOutlined, HomeOutlined, UserOutlined } from '@ant-design/icons';
import { API } from '../../http';
import { NEW_ENDPOINTS } from '../../http/endpoints';
import classes from './UserPreview.module.scss';
import moment from 'moment';
import { FIELDS_SCHEME, GENERAL_SCHEME } from '../../schemas';
import _ from 'lodash';
import TransactionsTable from '../../components/TransactionsTable/TransactionsTable';
import { ROUTES } from '../../components/AppRouter/AppRouter';
import { handleFileToBase64 } from '../../utils/helpers';
import { generateSumSubLink } from '../../actions/users';
import AddCompanyMemberModal from '../../components/AddCompanyMemberModal/AddCompanyMemberModal';
import CorporateFilesTab from './сomponents/CorporateFilesTab';
import Score from './сomponents/Score';
import DeductFee from './сomponents/DeductFee';
import { useSelector } from 'react-redux';
import { getUser } from '../../store/selectors';

const BLOCKING_REASONS = {
  tspInvestigation: {
    label: 'TSP investigation',
    login: false,
    creditDebit: false,
    credit: false,
    debit: true,
    amount: false
  },
  tspRefreining: {
    label: 'TSP refreining',
    login: false,
    creditDebit: false,
    credit: false,
    debit: true,
    amount: false
  },
  fiuFreeze: {
    label: 'FIU freeze',
    login: false,
    creditDebit: false,
    credit: false,
    debit: true,
    amount: false
  },
  leaArrest: {
    label: 'LEA arrest',
    login: false,
    creditDebit: false,
    credit: false,
    debit: false,
    amount: true
  },
  leaConfiscationOwner: {
    label: 'LEA confiscation (lawful owner)',
    login: false,
    creditDebit: false,
    credit: false,
    debit: false,
    amount: true
  },
  leaConfiscationState: {
    label: 'LEA confiscation (state)',
    login: false,
    creditDebit: false,
    credit: false,
    debit: false,
    amount: true
  },
  srsBlock: {
    label: 'SRS block',
    login: false,
    creditDebit: false,
    credit: false,
    debit: false,
    amount: true
  },
  courtBailiffs: {
    label: 'Court bailiffs block',
    login: false,
    creditDebit: false,
    credit: false,
    debit: false,
    amount: true
  },
  sanctions: {
    label: 'Sanctions',
    login: false,
    creditDebit: true,
    credit: false,
    debit: false,
    amount: false
  },
  tspCustomerDeceased: {
    label: 'TSP customer DECEASED',
    login: true,
    creditDebit: true,
    credit: false,
    debit: false,
    amount: false
  },
  tspAccessLost: {
    label: 'TSP access lost',
    login: true,
    creditDebit: false,
    credit: false,
    debit: true,
    amount: false
  },
  tspFraud: {
    label: 'TSP fraud',
    login: true,
    creditDebit: false,
    credit: false,
    debit: true,
    amount: false
  },
  tspNewPoa: {
    label: 'TSP new POA',
    login: false,
    creditDebit: false,
    credit: false,
    debit: true,
    amount: false
  },
  tspInfoRequest: {
    label: 'TSP info request',
    login: false,
    creditDebit: false,
    credit: false,
    debit: true,
    amount: false
  },
  tspMonitoring: {
    label: 'TSP increased monitoring',
    login: false,
    creditDebit: false,
    credit: false,
    debit: true,
    amount: false
  },
  closedByClient: {
    label: 'Closed by client',
    login: true,
    creditDebit: true,
    credit: false,
    debit: false,
    amount: false
  },
  closedByTsp: {
    label: 'Closed by TSP',
    login: true,
    creditDebit: true,
    credit: false,
    debit: false,
    amount: false
  },
  closedBlackList: {
    label: 'Closed black list',
    login: true,
    creditDebit: true,
    credit: false,
    debit: false,
    amount: false
  }
};

const UserPreview = ({}) => {
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [tariffs, setTariffs] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [isChanged, setIsChanged] = useState(false);
  const [members, setMembers] = useState([]);
  const [corporateData, setCorporateData] = useState([]);
  const [signedDoc, setSignedDoc] = useState();
  const [contractExists, setContractExists] = useState(false);
  const [amlExists, setAmlExists] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [form] = Form.useForm();

  const { id } = useParams();
  const navigate = useNavigate();

  const admin = useSelector(getUser);

  const handleOpenDocument = (data) => {
    const byteCharacters = atob(data.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const blobURL = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobURL;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(blobURL);
  };

  const membersColumns = [
    {
      title: 'ID',
      dataIndex: ['user', 'id'],
      key: 'id',
      width: 180,
      render: (value) => (
        <Typography.Text copyable={{ text: value }} ellipsis={{ tooltip: value }}>
          {value || '-/-'}
        </Typography.Text>
      )
    },
    {
      title: 'Name',
      key: 'name',
      width: 150,
      render: (_, record) => {
        const { first_name, last_name } = record.account;
        const fullName = [first_name, last_name].filter(Boolean).join(' ');
        if (!fullName) return <Typography.Text>Unknown</Typography.Text>;
        return (
          <Typography.Link
            onClick={() =>
              navigate(`${ROUTES.USER.path}/${record.user.id}`, {
                state: { user: record }
              })
            }
            copyable
            ellipsis>
            {fullName}
          </Typography.Link>
        );
      }
    },
    {
      title: 'Ownership',
      dataIndex: ['percent'],
      key: 'percent',
      width: 180,
      render: (value) => <Typography.Text>{`${value}%` || '-/-'}</Typography.Text>
    },
    {
      title: 'E-mail',
      dataIndex: ['account', 'email_address'],
      key: 'email_address',
      width: 250,
      render: (value) => (
        <Typography.Text ellipsis={{ tooltip: value }} copyable={{ text: value }}>
          {value || '-/-'}
        </Typography.Text>
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 50,
      align: 'center',
      render: (_, record) => (
        <Button
          onClick={async () => {
            const member_id = record.user.id;
            setLoading(true);
            try {
              await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.DELETE_MEMBER, {
                corporate_id: id,
                member_id
              });
              setMembers((prevMembers) =>
                prevMembers.filter((member) => member.user.id !== member_id)
              );
            } catch (error) {
              message.error('Failed to remove member');
            } finally {
              setLoading(false);
            }
          }}
          danger>
          Delete
        </Button>
      )
    }
  ];

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const { data } = await API.post(NEW_ENDPOINTS.ADMIN.TRANSACTIONS.LIST, {
        user_id: id
      });
      setTransactions(data);
    } catch (error) {
      message.error('Failed to load transactions');
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchCorporateInfo = async () => {
    try {
      const {
        data: { members: _members = [], info }
      } = await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.INFO, {
        corporate_id: id,
        full: true
      });
      setMembers(_members);
      setCorporateData(info);

      const {
        data: { exists: existsContact }
      } = await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.SIGNED, {
        corporate_id: id
      });
      setContractExists(existsContact);

      const {
        data: { exists: existsAml }
      } = await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.AML_EXISTS, {
        corporate_id: id
      });
      setAmlExists(existsAml);
    } catch (error) {
      message.error('Failed to fetch corporate information');
    }
  };
  const onFinish = async ({ overdraft, blockings, ...formData }) => {
    setLoading(true);
    try {
      await API.post(NEW_ENDPOINTS.ADMIN.USER.UPDATE, { uid: currentUser.id, ...formData });
      if (currentUser.corporate_confirm !== formData.corporate_confirm) {
        try {
          await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.CONFIRM, {
            corporate_id: currentUser.id,
            corporate_confirm: formData.corporate_confirm
          });
        } catch (e) {
          message.error('Failed to confirm corporation');
          console.error('Error uploading signed document: ', e);
        }
      }
      setCurrentUser((prev) => ({ ...prev, ...formData }));
      form.setFieldsValue(formData);
      message.success('User updated successfully');

      // SET OVERDRAFT
      try {
        await API.post(NEW_ENDPOINTS.ADMIN.USER.SET_OVERDRAFT, {
          type_overdraft: 'negative',
          userId: currentUser.id,
          overdraft: parseInt(overdraft)
        });
        setCurrentUser((prev) => ({ ...prev, overdraft }));
        form.setFieldsValue({ overdraft });
      } catch (error) {
        message.error('Failed to set overdraft');
        if (error.data?.error) {
          message.error(error.data.error);
          return;
        }
      }

      const newBlockings = defineBlockings(blockings);
      await setBlockings(newBlockings);
      form.setFieldsValue({ blockings: [] });
    } catch (error) {
      if (error.data?.error) {
        message.error(error.data.error);
        return;
      }
      message.error('Failed to update user');
      form.setFieldsValue(currentUser);
    } finally {
      setIsChanged(false);
      setLoading(false);
      setEditMode(false);
    }
  };

  const setBlockings = async (blockings) => {
    if (!blockings) return;

    if (blockings.login) {
      await API.post(NEW_ENDPOINTS.ADMIN.USER.BLOCK.LOGIN, {
        block_login: true,
        userId: currentUser.id
      });
      if (!currentUser.blocking.includes('LOGIN'))
        setCurrentUser((prev) => ({ ...prev, blocking: [...prev.blocking, 'LOGIN'] }));
    }
    if (blockings.creditDebit) {
      await API.post(NEW_ENDPOINTS.ADMIN.USER.BLOCK.ORDER, {
        block_order: true,
        userId: currentUser.id
      });
      if (!currentUser.blocking.includes('CREATE_ORDER'))
        setCurrentUser((prev) => ({ ...prev, blocking: [...prev.blocking, 'CREATE_ORDER'] }));
    }
  };

  const onValuesChange = (field, allValues) => {
    const compareUserData = {
      first_name: currentUser.first_name,
      last_name: currentUser.last_name,
      risk_level: currentUser.risk_level,
      email_address: currentUser.email_address,
      tariff: currentUser.tariff,
      corporate_confirm: currentUser.corporate_confirm,
      overdraft: currentUser.overdraft,
      blockings: undefined
    };
    setIsChanged(!_.isEqual(compareUserData, allValues));
  };

  const defineBlockings = (blockingStrings) => {
    if (!blockingStrings?.length) return;

    let login = false;
    let creditDebit = false;

    blockingStrings.forEach((blockingString) => {
      const blocking = BLOCKING_REASONS[blockingString];
      login = login || blocking['login'];
      creditDebit = creditDebit || blocking['creditDebit'];
    });

    return {
      login,
      creditDebit
    };
  };

  useEffect(() => {
    if (id) {
      fetchUsers();
      fetchTransactions();
      fetchTariffs();
    }
  }, [id]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const {
          data: { rr: _users }
        } = await API.post(NEW_ENDPOINTS.ADMIN.USER.GET_LIST),
        _currentUser = _users.find((user) => user.id === id);
      setCurrentUser(_currentUser);
      form.setFieldsValue(_currentUser);
      if (_currentUser.is_corporate) await fetchCorporateInfo();
    } catch (error) {
      message.error('Failed to fetch users');
    } finally {
      setLoading(false);
    }
  };
  const fetchTariffs = async () => {
    setLoading(true);
    try {
      const { data } = await API.get(NEW_ENDPOINTS.ADMIN.TARIFFS, {
        headers: {
          token: 'my1perfect2token'
        }
      });
      setTariffs(data);
    } catch (e) {
      message.error('Error fetching tariffs list');
      setTariffs([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddMember = async (member) => {
    const { position, percent, user_id: formUserId, ...formData } = member;
    setLoading(true);
    try {
      if (formUserId) {
        await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.ADD_MEMBER, {
          corporate_id: id,
          member_id: formUserId,
          position,
          percent
        });
        await fetchCorporateInfo();
      } else {
        const {
          data: {
            result: { success, data: msg, user_id }
          }
        } = await API.post(NEW_ENDPOINTS.ADMIN.USER.CREATE, {
          ...formData,
          email: formData.email_address
        });
        if (success) {
          await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.ADD_MEMBER, {
            corporate_id: id,
            member_id: user_id,
            position,
            percent
          });
          await fetchCorporateInfo();
        } else {
          message.error(msg);
        }
      }
    } catch (e) {
      message.error('Error adding member');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadTemplate = async () => {
    setLoading(true);
    try {
      const { data } = await API.post(
        NEW_ENDPOINTS.ADMIN.USER.CORPORATION.GENERATE_DOC,
        {
          corporate_id: id
        },
        {
          responseType: 'blob'
        }
      );
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'doc_to_sign.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (e) {
      message.error('Something went wrong...');
      console.error('Error downloading template: ', e);
    } finally {
      setLoading(false);
    }
  };
  const handleDownloadSignedContract = async () => {
    setLoading(true);
    try {
      const { data } = await API.post(
        NEW_ENDPOINTS.ADMIN.USER.CORPORATION.SIGNED_DOC,
        {
          corporate_id: id
        },
        {
          responseType: 'blob'
        }
      );
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Signed_Contract.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      message.error('Failed to download the signed document.');
      console.error('Error downloading the signed document:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleDownloadAMLReport = async () => {
    setLoading(true);
    try {
      const { data, headers } = await API.post(
        NEW_ENDPOINTS.ADMIN.USER.CORPORATION.AML_DOWNLOAD,
        {
          corporate_id: id
        },
        {
          responseType: 'blob'
        }
      );
      const mimeType = headers['content-type'] || 'application/octet-stream';
      const blob = new Blob([data], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'aml_report');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      message.error('Failed to download the signed document.');
      console.error('Error downloading the signed document:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleSignedDocumentChange = async (info) => {
    const { fileList } = info;
    if (fileList.length === 0) {
      setSignedDoc(null);
    } else {
      const file = fileList[0];
      if (file.status && (file.status === 'error' || file.status === 'removed')) {
        setSignedDoc(null);
      } else {
        setSignedDoc(file.originFileObj);
      }
    }
  };
  const handleUploadAmlReport = async (info) => {
    const { fileList } = info;
    if (fileList.length === 0) {
      setAmlExists(false);
    } else {
      const file = fileList[0];
      if (file.status && (file.status === 'error' || file.status === 'removed')) {
        setAmlExists(false);
      } else {
        const fileObj = file.originFileObj;
        const fileObjBase64 = await handleFileToBase64(fileObj);
        await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.AML_UPLOAD, {
          corporate_id: id,
          filename: fileObj.name,
          content_type: fileObj.type,
          document: fileObjBase64
        });
        message.success('File uploaded');
        setAmlExists(true);
      }
    }
  };
  const sendSignedDocument = async () => {
    if (!signedDoc) {
      message.error('Please upload a signed document first.');
      return;
    }

    setLoading(true);
    try {
      const signedFileBase64 = await handleFileToBase64(signedDoc);
      await API.post(NEW_ENDPOINTS.ADMIN.USER.CORPORATION.SIGN, {
        corporate_id: id,
        pdf: signedFileBase64
      });
      setSignedDoc(undefined);
      setContractExists(true);
    } catch (e) {
      message.error('Failed to upload signed document');
      console.error('Error uploading signed document: ', e);
    } finally {
      setLoading(false);
    }
  };
  const handleFileUpload = (file) => {
    if (file.type !== 'application/pdf') {
      message.error('Only PDF files are allowed');
      return Upload.LIST_IGNORE;
    }
    if (file.size / 1024 / 1024 > 100) {
      message.error('File must be smaller than 100MB');
      return Upload.LIST_IGNORE;
    }
    return false;
  };

  const _generateSumSubLink = async (userId) => {
    setLoading(true);
    generateSumSubLink(userId).finally(() => setLoading(false));
  };

  return (
    <Container>
      <Spin tip='Loading...' spinning={loading}>
        <Form variant='filled' onValuesChange={onValuesChange} form={form} onFinish={onFinish}>
          <Block>
            {currentUser.is_corporate && currentUser.corporate_confirm === false && (
              <Alert
                style={{ marginBottom: 20 }}
                message='This corporation is not confirmed'
                type='warning'
                showIcon
              />
            )}

            <div className={classes.userProfileContainer}>
              <div className={classes.avatarContainer}>
                <Avatar
                  size={100}
                  icon={currentUser.is_corporate ? <HomeOutlined /> : <UserOutlined />}
                />
              </div>

              <Flex vertical>
                <div className={classes.nameContainer}>
                  {editMode ? (
                    <Space style={{ marginBottom: 10 }} size='small' align='center'>
                      <Form.Item
                        style={{ marginBottom: 0 }}
                        name='first_name'
                        rules={[...FIELDS_SCHEME.name, ...GENERAL_SCHEME.required]}>
                        <Input />
                      </Form.Item>
                      {!currentUser.is_corporate && (
                        <Form.Item
                          style={{ marginBottom: 0 }}
                          name='last_name'
                          rules={[...FIELDS_SCHEME.name, ...GENERAL_SCHEME.required]}>
                          <Input />
                        </Form.Item>
                      )}
                    </Space>
                  ) : (
                    <Space>
                      <Typography.Title style={{ marginBottom: 0 }} level={3}>
                        {[currentUser.first_name, currentUser.last_name].join(' ')}
                      </Typography.Title>
                      {currentUser.is_corporate ? (
                        <Tag bordered={false} color='volcano'>
                          Corporation
                        </Tag>
                      ) : (
                        <Tag bordered={false} color='blue'>
                          Individual
                        </Tag>
                      )}
                    </Space>
                  )}

                  <Space split={<Divider type='vertical' />}>
                    <Typography.Text>id: {currentUser.id}</Typography.Text>
                    {editMode ? (
                      <Form.Item
                        style={{ marginBottom: 0 }}
                        name='email_address'
                        rules={[...FIELDS_SCHEME.email, ...GENERAL_SCHEME.required]}>
                        <Input />
                      </Form.Item>
                    ) : (
                      <Typography.Link href={`mailto:${currentUser.email_address}`}>
                        {currentUser.email_address}
                      </Typography.Link>
                    )}
                  </Space>
                </div>
                <Descriptions column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 2, xxl: 2 }}>
                  {!!currentUser?.iban && (
                    <Descriptions.Item label='IBAN'>{currentUser.iban}</Descriptions.Item>
                  )}
                  <Descriptions.Item label='Balance'>
                    {currentUser.balance?.toFixed(2)} EUR | {currentUser.balance_gbp?.toFixed(2)}{' '}
                    GBP
                  </Descriptions.Item>
                  <Descriptions.Item label='Account created'>
                    <Typography.Text>
                      {moment(currentUser.createdAt).format('LLL') || '-/-'}
                    </Typography.Text>
                  </Descriptions.Item>
                  <Descriptions.Item label='Transactions found'>
                    <Typography.Text>{transactions.length || '-/-'}</Typography.Text>
                  </Descriptions.Item>
                  <Descriptions.Item labelStyle={{ alignItems: 'center' }} label='Risk Level'>
                    {editMode ? (
                      <Form.Item
                        style={{ marginBottom: 0 }}
                        rules={GENERAL_SCHEME.required}
                        name='risk_level'>
                        <Select style={{ width: 120 }}>
                          <Select.Option value={0}>0</Select.Option>
                          <Select.Option value={1}>1</Select.Option>
                          <Select.Option value={2}>2</Select.Option>
                          <Select.Option value={3}>3</Select.Option>
                          <Select.Option value={4}>4</Select.Option>
                        </Select>
                      </Form.Item>
                    ) : (
                      <Typography.Text>{currentUser.risk_level ?? '-/-'}</Typography.Text>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item labelStyle={{ alignItems: 'center' }} label='Risk Score'>
                    <Score currentUser={currentUser} id={id} fetchUsers={fetchUsers} />
                  </Descriptions.Item>
                  <Descriptions.Item labelStyle={{ alignItems: 'center' }} label='Tariff'>
                    {editMode ? (
                      <Form.Item style={{ marginBottom: 0 }} name='tariff'>
                        <Select style={{ width: 180 }}>
                          {/*<Select.Option value={null}>No tariff</Select.Option>*/}
                          {tariffs.map((item) => (
                            <Select.Option value={item.id}>{item.name || item.id}</Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    ) : (
                      <Typography.Text>{currentUser.tariff || '-/-'}</Typography.Text>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label='Sumsub ID'>
                    <Typography.Text>{currentUser.sumsub_id || '-/-'}</Typography.Text>
                  </Descriptions.Item>
                  <Descriptions.Item label='Sumsub Status'>
                    <Typography.Text>
                      {currentUser.sumsub_status || '-/-'}&nbsp; (
                      <Typography.Link
                        disabled={loading}
                        onClick={_generateSumSubLink.bind(this, currentUser.id)}>
                        Get verification link
                      </Typography.Link>
                      )
                    </Typography.Text>
                  </Descriptions.Item>
                  <Descriptions.Item label='Address'>
                    <Typography.Text>
                      {[
                        currentUser.country,
                        currentUser.city,
                        currentUser.street,
                        currentUser.zip_code
                      ]
                        .filter(Boolean)
                        .join(', ') || '-/-'}
                    </Typography.Text>
                  </Descriptions.Item>
                  <Descriptions.Item label='Overdraft'>
                    <Typography.Text>
                      {editMode &&
                      (admin.role === 'admin' || admin.role === 'mlro' || admin.role === 'aml') ? (
                        <Form.Item name='overdraft' rules={[...GENERAL_SCHEME.required]}>
                          <InputNumber
                            defaultValue={currentUser.overdraft}
                            style={{ width: 120 }}
                            max={0}
                            step={1}
                          />
                        </Form.Item>
                      ) : (
                        parseInt(currentUser.overdraft)?.toFixed(2) || '-/-'
                      )}
                    </Typography.Text>
                  </Descriptions.Item>
                  <Descriptions.Item label='Blockings'>
                    <Typography.Text>
                      {currentUser.blocking?.filter(Boolean).join(', ') || '-/-'}
                      {editMode &&
                        (admin.role === 'admin' ||
                          admin.role === 'mlro' ||
                          admin.role === 'aml') && (
                          <Flex alignItems='center' vertical style={{ marginTop: 10 }}>
                            <Typography.Text>Add blocking reason</Typography.Text>
                            <Form.Item name='blockings'>
                              <Select
                                mode='multiple'
                                style={{ width: 180 }}
                                placeholder='Select blockings'>
                                {Object.keys(BLOCKING_REASONS).map((key) => (
                                  <Select.Option value={key}>
                                    {BLOCKING_REASONS[key].label}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Flex>
                        )}
                    </Typography.Text>
                  </Descriptions.Item>
                  {currentUser.is_corporate && (
                    <Descriptions.Item labelStyle={{ alignItems: 'center' }} label='Confirm Status'>
                      {editMode ? (
                        <Form.Item
                          style={{ marginBottom: 0 }}
                          rules={GENERAL_SCHEME.required}
                          name='corporate_confirm'>
                          <Select style={{ width: 120 }}>
                            <Select.Option value={true}>Confirmed</Select.Option>
                            <Select.Option value={false}>Not confirmed</Select.Option>
                          </Select>
                        </Form.Item>
                      ) : (
                        <>
                          {currentUser.corporate_confirm ? (
                            <Tag color='green'>Confirmed</Tag>
                          ) : (
                            <Tag color='red'>Not confirmed</Tag>
                          )}
                        </>
                      )}
                    </Descriptions.Item>
                  )}
                </Descriptions>
              </Flex>

              {editMode ? (
                <Space size='small' align='center'>
                  <Button
                    onClick={() => {
                      setEditMode(false);
                      form.setFieldsValue(currentUser);
                    }}>
                    Cancel
                  </Button>
                  <Button
                    type='primary'
                    htmlType='submit'
                    disabled={
                      !isChanged ||
                      form.getFieldsError().filter(({ errors }) => errors.length).length
                    }>
                    Save Changes
                  </Button>
                </Space>
              ) : (
                <Button onClick={() => setEditMode(true)}>Edit Profile</Button>
              )}
            </div>

            <Tabs size='large' defaultActiveKey='transactions'>
              <Tabs.TabPane tab='Transactions' key='transactions'>
                <TransactionsTable
                  onStatusUpdate={() => fetchTransactions(id)}
                  transactions={transactions}
                  excludeColumns={['client_name']}
                  loading={loading}
                />
              </Tabs.TabPane>
              <Tabs.TabPane tab='Deduct Fee' key='fee'>
                <DeductFee
                  userId={id}
                  loading={loading}
                  setLoading={setLoading}
                  fetchTransactions={fetchTransactions}
                />
              </Tabs.TabPane>

              {currentUser.is_corporate && (
                <>
                  <Tabs.TabPane tab={`Members (${members.length ?? '-/-'})`} key='members'>
                    <Space direction='vertical' className='w100'>
                      <Button size='large' onClick={() => setIsModalVisible(true)}>
                        Add Member
                      </Button>
                      <Table
                        dataSource={members}
                        columns={membersColumns}
                        rowKey={(record) => record.user.id}
                        locale={{ emptyText: 'Members not found' }}
                        showSorterTooltip={false}
                        scroll={{ x: 630 }}
                        pagination={{ position: ['none', 'bottomCenter'], hideOnSinglePage: true }}
                      />
                    </Space>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab='Contract' key='contract'>
                    {contractExists ? (
                      <Result
                        status='success'
                        title='The corporation is confirmed'
                        extra={[
                          <Button
                            size='large'
                            key='download'
                            type='primary'
                            onClick={handleDownloadSignedContract}>
                            Download Signed Contract
                          </Button>
                        ]}
                      />
                    ) : (
                      <Result
                        status='warning'
                        title='Download the contract, sign it, and upload the signed version'
                        extra={
                          <Space direction='vertical' size='large'>
                            <Button onClick={handleDownloadTemplate}>Download Template</Button>
                            <Upload.Dragger
                              accept='application/pdf'
                              listType='picture'
                              maxCount={1}
                              progress={{
                                strokeColor: {
                                  '0%': '#108ee9',
                                  '100%': '#87d068'
                                },
                                strokeWidth: 3,
                                format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`
                              }}
                              multiple={false}
                              onChange={handleSignedDocumentChange}
                              beforeUpload={handleFileUpload}>
                              <p className='ant-upload-drag-icon'>
                                <FileTextOutlined />
                              </p>
                              <p className='ant-upload-text'>
                                Click or drag the signed document to this area
                              </p>
                              <p className='ant-upload-hint'>
                                Only one PDF file is allowed. The file must be smaller than 100MB.
                              </p>
                            </Upload.Dragger>
                            <Button
                              type='primary'
                              onClick={sendSignedDocument}
                              disabled={!signedDoc || loading}>
                              Upload Signed Contract
                            </Button>
                          </Space>
                        }
                      />
                    )}
                  </Tabs.TabPane>
                  <Tabs.TabPane tab='Corporate Info' key='info'>
                    <Descriptions bordered column={1} size='small'>
                      {corporateData && corporateData.length > 0 ? (
                        corporateData.map((item, index) =>
                          item.is_file ? (
                            <Descriptions.Item key={index} label={item.name}>
                              <Button onClick={() => handleOpenDocument(item.value)}>View</Button>
                            </Descriptions.Item>
                          ) : (
                            <Descriptions.Item key={index} label={item.name}>
                              {item.value}
                            </Descriptions.Item>
                          )
                        )
                      ) : (
                        <Descriptions.Item label='Info'>
                          No corporate information available.
                        </Descriptions.Item>
                      )}
                    </Descriptions>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab='AML Report' key='aml'>
                    {amlExists ? (
                      <Result
                        status='success'
                        title='AML Report Uploaded'
                        extra={[
                          <Button
                            loading={loading}
                            size='large'
                            key='download'
                            type='primary'
                            onClick={handleDownloadAMLReport}>
                            Download AML Report
                          </Button>
                        ]}
                      />
                    ) : (
                      <Result status='info' title='No AML Report Found' />
                    )}
                    <Upload.Dragger
                      listType='picture'
                      maxCount={1}
                      progress={{
                        strokeColor: {
                          '0%': '#108ee9',
                          '100%': '#87d068'
                        },
                        strokeWidth: 3,
                        format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`
                      }}
                      multiple={false}
                      onChange={handleUploadAmlReport}
                      beforeUpload={(file) => {
                        if (file.size / 1024 / 1024 > 100) {
                          message.error('File must be smaller than 100MB');
                          return Upload.LIST_IGNORE;
                        }
                        return false;
                      }}>
                      <p className='ant-upload-drag-icon'>
                        <FileTextOutlined />
                      </p>
                      <p className='ant-upload-text'>Click or drag your report to this area</p>
                      <p className='ant-upload-hint'>The file must be smaller than 100MB.</p>
                    </Upload.Dragger>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab='Files' key='files'>
                    <CorporateFilesTab corporateId={id} />
                  </Tabs.TabPane>
                </>
              )}
            </Tabs>
          </Block>
        </Form>
      </Spin>
      <AddCompanyMemberModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        onSubmit={handleAddMember}
      />
    </Container>
  );
};

export default UserPreview;
